// mds-dojo — dijit/form/_ListMouseMixin — FAITHFUL port of references/dijit/form/_ListMouseMixin.js.
// Codemod pipeline; declare from the faithful runtime. No adaptations beyond import rewrites.
// dojo/touch is imported for its side-effect: postCreate sets domNode.dojoClick, which dojo/touch's
// normalized click handling reads. Kept as a bare side-effect import (the binding is never referenced
// directly), matching real dojo's dependency on the touch module being loaded.
import declare from '../../dojo/_base/declare-runtime'; // declare
import '../../dojo/touch';
import _ListBase from './_ListBase';

export default declare("dijit.form._ListMouseMixin", _ListBase, {
	// summary:
	//		A mixin to handle mouse or touch events for a focus-less menu
	//		Abstract methods that must be defined externally:
	//
	//		- onClick: item was chosen (mousedown somewhere on the menu and mouseup somewhere on the menu)
	// tags:
	//		private

	postCreate: function () {
		this.inherited(arguments);

		// Add flag to use normalized click handling from dojo/touch
		this.domNode.dojoClick = true;

		this._listConnect("click", "_onClick");
		this._listConnect("mousedown", "_onMouseDown");
		this._listConnect("mouseup", "_onMouseUp");
		this._listConnect("mouseover", "_onMouseOver");
		this._listConnect("mouseout", "_onMouseOut");
	},

	_onClick: function (/*Event*/ evt: any, /*DomNode*/ target: any) {
		this._setSelectedAttr(target, false);
		if (this._deferredClick) {
			this._deferredClick.remove();
		}
		this._deferredClick = this.defer(function (this: any) {
			this._deferredClick = null;
			this.onClick(target);
		});
	},

	_onMouseDown: function (/*Event*/ evt: any, /*DomNode*/ target: any) {
		if (this._hoveredNode) {
			this.onUnhover(this._hoveredNode);
			this._hoveredNode = null;
		}
		this._isDragging = true;
		this._setSelectedAttr(target, false);
	},

	_onMouseUp: function (/*Event*/ evt: any, /*DomNode*/ target: any) {
		this._isDragging = false;
		var selectedNode = this.selected;
		var hoveredNode = this._hoveredNode;
		if (selectedNode && target == selectedNode) {
			this.defer(function (this: any) {
				this._onClick(evt, selectedNode);
			});
		} else if (hoveredNode) { // drag to select
			this.defer(function (this: any) {
				this._onClick(evt, hoveredNode);
			});
		}
	},

	_onMouseOut: function (/*Event*/ evt: any, /*DomNode*/ target: any) {
		if (this._hoveredNode) {
			this.onUnhover(this._hoveredNode);
			this._hoveredNode = null;
		}
		if (this._isDragging) {
			this._cancelDrag = (new Date()).getTime() + 1000; // cancel in 1 second if no _onMouseOver fires
		}
	},

	_onMouseOver: function (/*Event*/ evt: any, /*DomNode*/ target: any) {
		if (this._cancelDrag) {
			var time = (new Date()).getTime();
			if (time > this._cancelDrag) {
				this._isDragging = false;
			}
			this._cancelDrag = null;
		}
		this._hoveredNode = target;
		this.onHover(target);
		if (this._isDragging) {
			this._setSelectedAttr(target, false);
		}
	}
});
